import ApiClient from '../../../helpers/apiClient';

export const FETCH_ESIM_REPLACE_TOPUP_PRICE_REQUEST = 'FETCH_ESIM_REPLACE_TOPUP_PRICE_REQUEST';
export const FETCH_ESIM_REPLACE_TOPUP_PRICE_SUCCESS = 'FETCH_ESIM_REPLACE_TOPUP_PRICE_SUCCESS';
export const FETCH_ESIM_REPLACE_TOPUP_PRICE_ERROR = 'FETCH_ESIM_REPLACE_TOPUP_PRICE_ERROR';

export const IMPORT_ESIM_REPLACE_TOPUP_PRICE_REQUEST = 'IMPORT_ESIM_REPLACE_TOPUP_PRICE_REQUEST';
export const IMPORT_ESIM_REPLACE_TOPUP_PRICE_SUCCESS = 'IMPORT_ESIM_REPLACE_TOPUP_PRICE_SUCCESS';
export const IMPORT_ESIM_REPLACE_TOPUP_PRICE_ERROR = 'IMPORT_ESIM_REPLACE_TOPUP_PRICE_ERROR';

export const DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_REQUEST =
  'DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_REQUEST';
export const DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_SUCCESS =
  'DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_SUCCESS';
export const DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_ERROR =
  'DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_ERROR';

const baseUrl = 'payment/ESimReplaceTopUpPrices/';

export const fetchESimReplaceTopUpPrice = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_ESIM_REPLACE_TOPUP_PRICE_REQUEST,
        FETCH_ESIM_REPLACE_TOPUP_PRICE_SUCCESS,
        FETCH_ESIM_REPLACE_TOPUP_PRICE_ERROR,
      ],
      callAPI: () => ApiClient.post(baseUrl + 'Search', data),
      payload: { data },
    }),
  );
};

export const importESimReplaceTopUpPrice = file => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        IMPORT_ESIM_REPLACE_TOPUP_PRICE_REQUEST,
        IMPORT_ESIM_REPLACE_TOPUP_PRICE_SUCCESS,
        IMPORT_ESIM_REPLACE_TOPUP_PRICE_ERROR,
      ],
      callAPI: () =>
        ApiClient.post(baseUrl + 'Import', file, {
          headers: { 'Content-Type': 'multipart/form-data' },
        }),
      payload: { file },
    }),
  );
};

export const downloadESimReplaceTopUpPriceTemplate = () => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_REQUEST,
        DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_SUCCESS,
        DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_ERROR,
      ],
      callAPI: () =>
        ApiClient.get(baseUrl + 'DownloadTemplate', {
          responseType: 'blob',
        }),
      payload: {},
    }),
  );
};

const initialState = {
  payload: {},
  data: {},
  response: {},
  error: {},
  errorMessage: '',
  successMessage: '',
};

export default function reducer(state = initialState, action) {
  const { payload, response, error, successMessage, errorMessage } = action;
  switch (action.type) {
    case FETCH_ESIM_REPLACE_TOPUP_PRICE_REQUEST:
    case IMPORT_ESIM_REPLACE_TOPUP_PRICE_REQUEST:
    case DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_REQUEST:
      return {
        ...state,
        payload,
        response: {},
        error: {},
        successMessage: '',
        errorMessage: '',
      };

    case FETCH_ESIM_REPLACE_TOPUP_PRICE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          items: response.data.data.items,
          pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case IMPORT_ESIM_REPLACE_TOPUP_PRICE_SUCCESS:
    case DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_SUCCESS:
      return {
        ...state,
        response,
        successMessage,
      };

    case FETCH_ESIM_REPLACE_TOPUP_PRICE_ERROR:
    case IMPORT_ESIM_REPLACE_TOPUP_PRICE_ERROR:
    case DOWNLOAD_ESIM_REPLACE_TOPUP_PRICE_TEMPLATE_ERROR:
      return {
        ...state,
        payload,
        error,
        errorMessage,
      };

    default:
      return state;
  }
}
